import { render, staticRenderFns } from "./CompanyManagement.vue?vue&type=template&id=811f10a0&scoped=true&"
import script from "./CompanyManagement.vue?vue&type=script&lang=js&"
export * from "./CompanyManagement.vue?vue&type=script&lang=js&"
import style0 from "./CompanyManagement.vue?vue&type=style&index=0&id=811f10a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811f10a0",
  null
  
)

export default component.exports